module.exports = MOMOTA_RANKING = [
{"date": "2012-11-08", "worldRanking": 94},
{"date": "2012-11-16", "worldRanking": 94},
{"date": "2012-11-22", "worldRanking": 84},
{"date": "2012-11-29", "worldRanking": 84},
{"date": "2012-12-06", "worldRanking": 90},
{"date": "2012-12-13", "worldRanking": 89},
{"date": "2012-12-20", "worldRanking": 87},
{"date": "2012-12-27", "worldRanking": 90},
{"date": "2013-01-03", "worldRanking": 90},
{"date": "2013-01-10", "worldRanking": 89},
{"date": "2013-01-17", "worldRanking": 78},
{"date": "2013-01-25", "worldRanking": 64},
{"date": "2013-01-31", "worldRanking": 64},
{"date": "2013-02-07", "worldRanking": 64},
{"date": "2013-02-14", "worldRanking": 64},
{"date": "2013-02-21", "worldRanking": 63},
{"date": "2013-02-28", "worldRanking": 56},
{"date": "2013-03-07", "worldRanking": 52},
{"date": "2013-03-14", "worldRanking": 52},
{"date": "2013-03-21", "worldRanking": 51},
{"date": "2013-03-28", "worldRanking": 50},
{"date": "2013-04-04", "worldRanking": 49},
{"date": "2013-04-11", "worldRanking": 48},
{"date": "2013-04-18", "worldRanking": 46},
{"date": "2013-04-25", "worldRanking": 49},
{"date": "2013-05-02", "worldRanking": 51},
{"date": "2013-05-09", "worldRanking": 50},
{"date": "2013-05-16", "worldRanking": 50},
{"date": "2013-05-23", "worldRanking": 50},
{"date": "2013-05-30", "worldRanking": 50},
{"date": "2013-06-06", "worldRanking": 49},
{"date": "2013-06-13", "worldRanking": 54},
{"date": "2013-06-20", "worldRanking": 55},
{"date": "2013-06-27", "worldRanking": 44},
{"date": "2013-07-04", "worldRanking": 44},
{"date": "2013-07-11", "worldRanking": 43},
{"date": "2013-07-18", "worldRanking": 34},
{"date": "2013-07-25", "worldRanking": 35},
{"date": "2013-08-01", "worldRanking": 35},
{"date": "2013-08-07", "worldRanking": 35},
{"date": "2013-08-15", "worldRanking": 35},
{"date": "2013-08-22", "worldRanking": 35},
{"date": "2013-08-29", "worldRanking": 35},
{"date": "2013-09-05", "worldRanking": 35},
{"date": "2013-09-12", "worldRanking": 35},
{"date": "2013-09-19", "worldRanking": 31},
{"date": "2013-09-26", "worldRanking": 29},
{"date": "2013-10-03", "worldRanking": 28},
{"date": "2013-10-10", "worldRanking": 28},
{"date": "2013-10-17", "worldRanking": 28},
{"date": "2013-10-24", "worldRanking": 27},
{"date": "2013-10-31", "worldRanking": 28},
{"date": "2013-11-07", "worldRanking": 28},
{"date": "2013-11-14", "worldRanking": 27},
{"date": "2013-11-21", "worldRanking": 20},
{"date": "2013-11-28", "worldRanking": 20},
{"date": "2013-12-05", "worldRanking": 18},
{"date": "2013-12-12", "worldRanking": 18},
{"date": "2013-12-19", "worldRanking": 17},
{"date": "2013-12-26", "worldRanking": 17},
{"date": "2014-01-02", "worldRanking": 17},
{"date": "2014-01-09", "worldRanking": 17},
{"date": "2014-01-16", "worldRanking": 14},
{"date": "2014-01-23", "worldRanking": 14},
{"date": "2014-01-30", "worldRanking": 14},
{"date": "2014-02-06", "worldRanking": 14},
{"date": "2014-02-13", "worldRanking": 14},
{"date": "2014-02-20", "worldRanking": 14},
{"date": "2014-02-27", "worldRanking": 15},
{"date": "2014-03-06", "worldRanking": 15},
{"date": "2014-03-13", "worldRanking": 13},
{"date": "2014-03-20", "worldRanking": 12},
{"date": "2014-03-27", "worldRanking": 12},
{"date": "2014-04-03", "worldRanking": 12},
{"date": "2014-04-10", "worldRanking": 12},
{"date": "2014-04-17", "worldRanking": 15},
{"date": "2014-04-24", "worldRanking": 14},
{"date": "2014-05-02", "worldRanking": 15},
{"date": "2014-05-08", "worldRanking": 14},
{"date": "2014-05-15", "worldRanking": 14},
{"date": "2014-05-22", "worldRanking": 14},
{"date": "2014-05-29", "worldRanking": 11},
{"date": "2014-06-05", "worldRanking": 11},
{"date": "2014-06-12", "worldRanking": 11},
{"date": "2014-06-19", "worldRanking": 12},
{"date": "2014-06-26", "worldRanking": 12},
{"date": "2014-07-03", "worldRanking": 15},
{"date": "2014-07-10", "worldRanking": 15},
{"date": "2014-07-17", "worldRanking": 15},
{"date": "2014-07-24", "worldRanking": 15},
{"date": "2014-07-31", "worldRanking": 15},
{"date": "2014-08-07", "worldRanking": 15},
{"date": "2014-08-14", "worldRanking": 14},
{"date": "2014-08-21", "worldRanking": 14},
{"date": "2014-08-28", "worldRanking": 14},
{"date": "2014-09-04", "worldRanking": 16},
{"date": "2014-09-11", "worldRanking": 16},
{"date": "2014-09-18", "worldRanking": 16},
{"date": "2014-09-25", "worldRanking": 16},
{"date": "2014-10-02", "worldRanking": 16},
{"date": "2014-10-09", "worldRanking": 16},
{"date": "2014-10-16", "worldRanking": 16},
{"date": "2014-10-23", "worldRanking": 15},
{"date": "2014-10-30", "worldRanking": 12},
{"date": "2014-11-06", "worldRanking": 12},
{"date": "2014-11-13", "worldRanking": 12},
{"date": "2014-11-20", "worldRanking": 15},
{"date": "2014-11-27", "worldRanking": 15},
{"date": "2014-12-04", "worldRanking": 15},
{"date": "2014-12-11", "worldRanking": 15},
{"date": "2014-12-18", "worldRanking": 14},
{"date": "2014-12-24", "worldRanking": 13},
{"date": "2015-01-02", "worldRanking": 13},
{"date": "2015-01-08", "worldRanking": 13},
{"date": "2015-01-15", "worldRanking": 12},
{"date": "2015-01-22", "worldRanking": 13},
{"date": "2015-01-29", "worldRanking": 14},
{"date": "2015-02-05", "worldRanking": 14},
{"date": "2015-02-12", "worldRanking": 14},
{"date": "2015-02-18", "worldRanking": 14},
{"date": "2015-02-26", "worldRanking": 14},
{"date": "2015-03-05", "worldRanking": 15},
{"date": "2015-03-12", "worldRanking": 16},
{"date": "2015-03-19", "worldRanking": 15},
{"date": "2015-03-26", "worldRanking": 15},
{"date": "2015-04-02", "worldRanking": 11},
{"date": "2015-04-09", "worldRanking": 10},
{"date": "2015-04-16", "worldRanking": 7},
{"date": "2015-04-23", "worldRanking": 7},
{"date": "2015-04-30", "worldRanking": 8},
{"date": "2015-05-07", "worldRanking": 8},
{"date": "2015-05-14", "worldRanking": 8},
{"date": "2015-05-21", "worldRanking": 8},
{"date": "2015-05-28", "worldRanking": 8},
{"date": "2015-06-04", "worldRanking": 9},
{"date": "2015-06-11", "worldRanking": 5},
{"date": "2015-06-18", "worldRanking": 4},
{"date": "2015-06-25", "worldRanking": 4},
{"date": "2015-07-02", "worldRanking": 4},
{"date": "2015-07-09", "worldRanking": 4},
{"date": "2015-07-16", "worldRanking": 4},
{"date": "2015-07-23", "worldRanking": 4},
{"date": "2015-07-30", "worldRanking": 4},
{"date": "2015-08-06", "worldRanking": 4},
{"date": "2015-08-13", "worldRanking": 4},
{"date": "2015-08-20", "worldRanking": 3},
{"date": "2015-08-27", "worldRanking": 3},
{"date": "2015-09-03", "worldRanking": 3},
{"date": "2015-09-10", "worldRanking": 3},
{"date": "2015-09-17", "worldRanking": 4},
{"date": "2015-09-23", "worldRanking": 4},
{"date": "2015-10-01", "worldRanking": 4},
{"date": "2015-10-08", "worldRanking": 4},
{"date": "2015-10-15", "worldRanking": 4},
{"date": "2015-10-22", "worldRanking": 4},
{"date": "2015-10-29", "worldRanking": 4},
{"date": "2015-11-05", "worldRanking": 4},
{"date": "2015-11-12", "worldRanking": 4},
{"date": "2015-11-19", "worldRanking": 4},
{"date": "2015-11-26", "worldRanking": 5},
{"date": "2015-12-03", "worldRanking": 5},
{"date": "2015-12-10", "worldRanking": 5},
{"date": "2015-12-17", "worldRanking": 3},
{"date": "2015-12-23", "worldRanking": 3},
{"date": "2015-12-31", "worldRanking": 3},
{"date": "2016-01-07", "worldRanking": 3},
{"date": "2016-01-14", "worldRanking": 3},
{"date": "2016-01-21", "worldRanking": 3},
{"date": "2016-01-28", "worldRanking": 4},
{"date": "2016-02-04", "worldRanking": 4},
{"date": "2016-02-11", "worldRanking": 4},
{"date": "2016-02-18", "worldRanking": 4},
{"date": "2016-02-25", "worldRanking": 3},
{"date": "2016-03-03", "worldRanking": 3},
{"date": "2016-03-10", "worldRanking": 3},
{"date": "2016-03-17", "worldRanking": 4},
{"date": "2016-03-24", "worldRanking": 4},
{"date": "2016-03-31", "worldRanking": 4},
{"date": "2016-04-07", "worldRanking": 2},
{"date": "2016-04-14", "worldRanking": 3},
{"date": "2016-04-21", "worldRanking": 4},
{"date": "2017-07-20", "worldRanking": 282},
{"date": "2017-07-27", "worldRanking": 277},
{"date": "2017-08-03", "worldRanking": 280},
{"date": "2017-08-10", "worldRanking": 211},
{"date": "2017-08-17", "worldRanking": 212},
{"date": "2017-08-24", "worldRanking": 209},
{"date": "2017-08-30", "worldRanking": 209},
{"date": "2017-09-07", "worldRanking": 209},
{"date": "2017-09-14", "worldRanking": 213},
{"date": "2017-09-21", "worldRanking": 162},
{"date": "2017-09-28", "worldRanking": 163},
{"date": "2017-10-05", "worldRanking": 110},
{"date": "2017-10-12", "worldRanking": 110},
{"date": "2017-10-19", "worldRanking": 77},
{"date": "2017-10-26", "worldRanking": 77},
{"date": "2017-11-02", "worldRanking": 75},
{"date": "2017-11-09", "worldRanking": 74},
{"date": "2017-11-16", "worldRanking": 48},
{"date": "2017-11-23", "worldRanking": 50},
{"date": "2017-11-30", "worldRanking": 48},
{"date": "2017-12-07", "worldRanking": 48},
{"date": "2017-12-14", "worldRanking": 48},
{"date": "2017-12-21", "worldRanking": 48},
{"date": "2017-12-28", "worldRanking": 48},
{"date": "2018-01-04", "worldRanking": 48},
{"date": "2018-01-11", "worldRanking": 48},
{"date": "2018-01-18", "worldRanking": 48},
{"date": "2018-01-25", "worldRanking": 50},
{"date": "2018-02-02", "worldRanking": 49},
{"date": "2018-02-08", "worldRanking": 49},
{"date": "2018-02-15", "worldRanking": 41},
{"date": "2018-02-22", "worldRanking": 42},
{"date": "2018-03-01", "worldRanking": 30, "worldTourRanking": 55},
{"date": "2018-03-08", "worldRanking": 30},
{"date": "2018-03-15", "worldRanking": 25, "worldTourRanking": 28},
{"date": "2018-03-22", "worldRanking": 26, "worldTourRanking": 43},
{"date": "2018-03-29", "worldRanking": 20},
{"date": "2018-04-05", "worldRanking": 20, "worldTourRanking": 44},
{"date": "2018-04-12", "worldRanking": 19},
{"date": "2018-04-19", "worldRanking": 17, "worldTourRanking": 47},
{"date": "2018-04-26", "worldRanking": 17},
{"date": "2018-05-03", "worldRanking": 12},
{"date": "2018-05-10", "worldRanking": 13, "worldTourRanking": 49},
{"date": "2018-05-17", "worldRanking": 12, "worldTourRanking": 59},
{"date": "2018-05-24", "worldRanking": 12},
{"date": "2018-05-31", "worldRanking": 12},
{"date": "2018-06-07", "worldRanking": 11},
{"date": "2018-06-14", "worldRanking": 11},
{"date": "2018-06-21", "worldRanking": 10, "worldTourRanking": 63},
{"date": "2018-06-28", "worldRanking": 11, "worldTourRanking": 65},
{"date": "2018-07-05", "worldRanking": 8, "worldTourRanking": 24},
{"date": "2018-07-12", "worldRanking": 6, "worldTourRanking": 8},
{"date": "2018-07-19", "worldRanking": 6, "worldTourRanking": 10},
{"date": "2018-07-26", "worldRanking": 7, "worldTourRanking": 13},
{"date": "2018-08-02", "worldRanking": 7, "worldTourRanking": 13},
{"date": "2018-08-09", "worldRanking": 4},
{"date": "2018-08-16", "worldRanking": 4, "worldTourRanking": 13},
{"date": "2018-08-23", "worldRanking": 4},
{"date": "2018-08-30", "worldRanking": 4},
{"date": "2018-09-06", "worldRanking": 4, "worldTourRanking": 13},
{"date": "2018-09-13", "worldRanking": 4, "worldTourRanking": 13},
{"date": "2018-09-20", "worldRanking": 2, "worldTourRanking": 8},
{"date": "2018-09-27", "worldRanking": 1, "worldTourRanking": 5},
{"date": "2018-10-04", "worldRanking": 1, "worldTourRanking": 6},
{"date": "2018-10-11", "worldRanking": 1, "worldTourRanking": 6},
{"date": "2018-10-18", "worldRanking": 1, "worldTourRanking": 6},
{"date": "2018-10-25", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2018-11-01", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2018-11-08", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2018-11-15", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2018-11-22", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2018-11-29", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2018-12-06", "worldRanking": 1},
{"date": "2018-12-13", "worldRanking": 1},
{"date": "2018-12-20", "worldRanking": 1},
{"date": "2018-12-27", "worldRanking": 1},
{"date": "2019-01-02", "worldRanking": 1},
{"date": "2019-01-08", "worldRanking": 1},
{"date": "2019-01-15", "worldRanking": 1},
{"date": "2019-01-22", "worldRanking": 1, "worldTourRanking": 33},
{"date": "2019-01-29", "worldRanking": 1, "worldTourRanking": 8},
{"date": "2019-02-05", "worldRanking": 1},
{"date": "2019-02-12", "worldRanking": 1},
{"date": "2019-02-19", "worldRanking": 1},
{"date": "2019-02-26", "worldRanking": 1, "worldTourRanking": 10},
{"date": "2019-03-05", "worldRanking": 1, "worldTourRanking": 4},
{"date": "2019-03-12", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-03-19", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-03-26", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-04-02", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-04-09", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-04-16", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-04-23", "worldRanking": 1},
{"date": "2019-04-30", "worldRanking": 1},
{"date": "2019-05-07", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-05-14", "worldRanking": 1},
{"date": "2019-05-21", "worldRanking": 1},
{"date": "2019-05-28", "worldRanking": 1},
{"date": "2019-06-04", "worldRanking": 1},
{"date": "2019-06-11", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2019-06-18", "worldRanking": 1},
{"date": "2019-06-25", "worldRanking": 1},
{"date": "2019-07-02", "worldRanking": 1},
{"date": "2019-07-09", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2019-07-16", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2019-07-23", "worldRanking": 1, "worldTourRanking": 3},
{"date": "2019-07-30", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-08-06", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-08-13", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-08-20", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-08-27", "worldRanking": 1},
{"date": "2019-09-03", "worldRanking": 1},
{"date": "2019-09-10", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-09-17", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2019-09-24", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-10-01", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-10-08", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-10-15", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-10-22", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-10-29", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-11-05", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-11-12", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-11-19", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-11-26", "worldRanking": 1, "worldTourRanking": 1},
{"date": "2019-12-03", "worldRanking": 1},
{"date": "2019-12-10", "worldRanking": 1},
{"date": "2019-12-17", "worldRanking": 1},
{"date": "2019-12-24", "worldRanking": 1},
{"date": "2019-12-31", "worldRanking": 1},
{"date": "2020-01-07", "worldRanking": 1},
{"date": "2020-01-14", "worldRanking": 1, "worldTourRanking": 2},
{"date": "2020-01-21", "worldRanking": 1, "worldTourRanking": 13},
{"date": "2020-01-28", "worldRanking": 1, "worldTourRanking": 18},
{"date": "2020-02-04", "worldRanking": 1},
{"date": "2020-02-11", "worldRanking": 1},
{"date": "2020-02-18", "worldRanking": 1},
{"date": "2020-02-25", "worldRanking": 1, "worldTourRanking": 23},
{"date": "2020-03-03", "worldRanking": 1},
{"date": "2020-03-10", "worldRanking": 1},
{"date": "2020-03-17", "worldRanking": 1, "worldTourRanking": 30}
]


//////////////////
// WEBPACK FOOTER
// ./static/js/momota-ranking.js
// module id = k7Ux
// module chunks = 1